import { spawn } from 'redux-saga/effects';
import { sagas as cartAdminQuoteCreateSagas } from './createModule';

export default function* sagas() {
	yield spawn(cartAdminQuoteCreateSagas);
}
